<template>
  <p class="text-sm text-gray-400">
    <slot />
  </p>
</template>

<script lang="ts" setup>
</script>